// vim: ft=javascriptreact
import { useState } from 'react'
import {
  Button,
  Alert,
  Form,
  Spinner,
} from 'react-bootstrap'
import useAuth from '../hooks/useAuth'
import { useNavigate } from 'react-router-dom'

const SignUpConfirmForm = () => {
  const { signUpConfirm, resendCode, email, authError, authInfo, hasYetToConfirmEmail } = useAuth()
  const [code, setCode] = useState('')
  const [signingUp, setSigningUp] = useState(false)
  const navigate = useNavigate()

  const onSignUpConfirm = async () => {
    setSigningUp(true)
    if (await signUpConfirm(code)) {
      setCode('')
      try {
        window.localStorage.setItem('email', email)
      } catch (e) {}
    }
    setSigningUp(false)
    navigate('/schedule')
  }

  const onResendCode = () => {
    setSigningUp(true)
    resendCode(email)
    setSigningUp(false)
  }

  if (signingUp) {
    return (
      <Spinner animation="border" role="status" variant="dark">
        <span className="visually-hidden">Signing Up...</span>
      </Spinner>
    )
  }

  return (
    <>
      <p className="lead"><strong>Please check your email for a verification code from "Imperial Booking".</strong></p>

      {authError && <Alert variant="danger">{authError}</Alert>}
      {authInfo && <Alert variant="info">{authInfo}</Alert>}
      {hasYetToConfirmEmail}

      <Form>
        <Form.Group className="mb-3" controlId="verification-code">
          <Form.Label>Verification Code</Form.Label>
          <Form.Control type="number" placeholder="e.g. 123456" value={code} onChange={(e) => setCode(e.target.value.replace(/[^0-9]/, '').substring(0, 6))} className="w-50" />
        </Form.Group>

        <Button variant="primary" size="lg" className="me-3" disabled={!code || code.length < 6} onClick={onSignUpConfirm}>Verify Account</Button>
        <Button variant="secondary" size="lg" className="me-3" onClick={onResendCode}>Resend Code</Button>
      </Form>
    </>
  )

}

export default SignUpConfirmForm
